import React, { useState } from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { payoutsService } from '@/services/payouts/payouts.service';

interface PayoutVideoButtonProps {
  payoutId: string;
  hasVideo: boolean;
}

const PayoutVideoButton: React.FC<PayoutVideoButtonProps> = ({ payoutId, hasVideo }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const close = () => {
    setOpen(false);
    setError(null);
    setVideoUrl(null);
  };

  const view = async () => {
    setOpen(true);
    setLoading(true);
    setError(null);
    try {
      const access = await payoutsService.getPayoutVideoAccess(payoutId);
      setVideoUrl(access.url);
    } catch {
      setError('Не удалось загрузить видео');
    } finally {
      setLoading(false);
    }
  };

  if (!hasVideo) return <>—</>;

  return (
    <>
      <Button size="small" variant="outlined" onClick={view}>
        Смотреть
      </Button>
      <Dialog open={open} onClose={close} maxWidth="md" fullWidth>
        <DialogTitle>Видео по выплате</DialogTitle>
        <DialogContent>
          {loading ? <CircularProgress /> : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
          {videoUrl ? (
            <video
              src={videoUrl}
              controls
              autoPlay
              preload="metadata"
              onError={() => {
                setError(
                  'Не удалось воспроизвести видео. Проверьте соединение и повторите попытку.',
                );
              }}
              style={{ display: 'block', width: '100%', maxHeight: '70vh' }}
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={close}>Закрыть</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PayoutVideoButton;
